import { useRef } from "react";

export const useCreationModalPending = () => {
    const isPendingRef = useRef(false);
    const setCreationModalPending = (open: boolean) => {
        isPendingRef.current = open;
    };
    return { isPendingRef, setCreationModalPending };
};
